import {TweenMax, TimelineLite, Expo, Power2} from "gsap";

const SCALE_MIN = 0;
const SCALE_MAX = 100;

class ProjectExperiment {

  constructor(opts) {

    this.parent = opts.parent;
    this.project = opts.project;
  }

  animateIn() {

    if(this.animatingOut) {
      this.animationOut.pause();
    }

    this.animatingIn = true;

    this.projectTexture = PIXI.Texture.fromFrame(this.project.id+'.png');

    this.projectContainer = new PIXI.Graphics();
    this.projectContainer.fillAlpha = 0;
    this.projectContainer.drawRect(0, 0, this.projectTexture.width*.5+200, this.projectTexture.height*.5+200);
    this.projectContainer.pivot = {x: (this.projectTexture.width*.5+200)*.5, y: (this.projectTexture.height*.5+200)*.5};
    // this.projectContainer.position = {x: -100, y: -100};
    this.projectContainer.position = {x: this.parent.bounds.width/2, y: this.parent.bounds.height/2};
    this.projectContainer.scale = {x: 1.15, y: 1.15};
    this.projectContainer.filters = [this.parent.displacementFilter];

    this.projectSprite = new PIXI.Sprite(this.projectTexture);
    this.projectSprite.position = {x: 100, y: 100};
    this.projectSprite.width = this.projectTexture.width*.5;
    this.projectSprite.height = this.projectTexture.height*.5;

    var border = new PIXI.Graphics();
    border.lineStyle(1, 0xf2f2f2);
    border.drawRect(this.projectSprite.x, this.projectSprite.y, this.projectSprite.width, this.projectSprite.height);

    this.projectContainer.addChild(this.projectSprite);
    this.projectContainer.addChild(border);
    this.parent.stage.addChild(this.projectContainer);

    this.animationIn = new TimelineLite({
      paused: true,
      onUpdateScope: this,
      onUpdate: function () {
        this.parent.dirty = true;
      },
      onCompleteScope: this,
      onComplete: function () {
        this.parent.dirty = true;
        this.animatingIn = false;
      },
    });

    this.animationIn.from(this.projectContainer, 2, {
      alpha: 0,
      rotation: (-.1+Math.random()*.2)*Math.PI,
      ease: Expo.easeOut
    });

    this.animationIn.to(this.projectContainer.scale, 1.5, {
      x: 1,
      y: 1,
      ease: Expo.easeOut
    }, 0);

    this.animationIn.to(this.parent.backgroundGraphic, 1.5, {
      alpha: 1,
      ease: Expo.easeOut
    }, 0);

    this.animationIn.fromTo(this.parent.displacementFilter.scale, 2, {
      x: SCALE_MAX,
      y: SCALE_MAX,
    }, {
      x: SCALE_MIN,
      y: SCALE_MIN,
      ease: Expo.easeOut
    }, 0.1);

    this.animationIn.play();
  }

  animateOut(callback) {

    if(this.animatingIn) {
      this.animationIn.pause();
    }

    this.animatingOut = true;

    this.animationOut = new TimelineLite({
      paused: true,
      onUpdateScope: this,
      onUpdate: function () {
        this.parent.dirty = true;
      },
      onCompleteScope: this,
      onComplete: function () {
        this.projectSprite.destroy();
        this.projectContainer.destroy();
        this.parent.displacementFilter.scale = {x: 0, y:0};

        this.parent.dirty = true;
        this.animatingOut = false;
        if(typeof callback === 'function') callback();
      },
    });

    this.animationOut.fromTo(this.parent.displacementFilter.scale, .3, {
      x: SCALE_MIN,
      y: SCALE_MIN,
    }, {
      x: SCALE_MAX,
      y: SCALE_MAX,
      ease: Expo.easeOut
    });

    this.animationOut.to(this.projectContainer, .3, {
      alpha: 0
    }, 0);

    this.animationOut.to(this.parent.backgroundGraphic, .3, {
      alpha: 0,
      ease: Expo.easeOut
    }, 0);

    this.animationOut.play();
  }

}

export default ProjectExperiment


// WEBPACK FOOTER //
// ./src/components/experiment/project-experiment.js